import { Box, Button, Heading } from "@ogt/ui";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function Unsubscribe() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();

  const handleUnsubscribe = () => {
    // TODO: Send unsubscribe token to backend
  };

  return (
    <Box fullwidth>
      <Heading
        className="h2"
        headingRef={h2Ref}
        id="thankYouHeading"
        focusable
      >
        Avregistrera nyhetsbrev
      </Heading>

      <div role="group">
        <p>
          Vill du avregistrera dig från nyhetsutskick? Klicka på knappen nedan
          för att bekräfta din avregistrering.
        </p>
        
        <Button
          size="medium"
          variant="primary"
          onClick={handleUnsubscribe}>
          Avregistrera nyhetsutskick
        </Button>
      </div>
    </Box>
  );
}
